/* SABBOT: tidy colour filter - names next to swatches, colour-family order, split swatches for two-tone, own show-all toggle */
(function () {
  var ORDER = ['white','cream','pale sand','beige','cappuccino','light grey','grey','dark grey','brown','russet','coral','red','burgundy','plum','pink','hot pink','purple','navy','denim blue','blue','dream blue','ocean blue','light blue','teal','forest','olive','green','lime','neon yellow','mustard','black'];
  var HEX = {black:'#000000',camel:'#c19a6b',pink:'#e79fab',blush:'#f6cfd8',navy:'#150a3d',sand:'#d8c7a0',lime:'#a6d608',mulberry:'#6b1f4f',grey:'#9a9aa6',stone:'#cfc6b4',rose:'#e39aa5',teal:'#008080',white:'#ffffff'};
  var SHOW = 16;
  function rank(name) {
    var n = name.toLowerCase().trim();
    var i = ORDER.indexOf(n);
    return i > -1 ? i : (n.indexOf('/') > -1 ? 100 : 90);
  }
  function tidy() {
    document.querySelectorAll('.collection__filter-tags--swatches').forEach(function (ul) {
      if (ul.dataset.sbTidy || ul.parentElement.closest('.collection__filter-tags--swatches')) return;
      ul.dataset.sbTidy = '1';
      ul.classList.add('sb-swatch-list');
      var items = [].slice.call(ul.querySelectorAll('li.collection__filter-tag--swatch'));
      var actions = ul.querySelector(':scope > .collection__filter-actions');
      items.forEach(function (li) {
        var label = li.querySelector('.swatch__label');
        var name = (label && label.getAttribute('data-swatch')) || '';
        li.dataset.sbRank = rank(name);
        if (name.indexOf('/') > -1) {
          var p = name.toLowerCase().split('/');
          var a = HEX[p[0].trim()], b = HEX[p[1].trim()];
          if (a && b) label.style.setProperty('background', 'linear-gradient(135deg,' + a + ' 50%,' + b + ' 50%)', 'important');
        }
        if (label && !li.querySelector('.sb-swatch-name')) {
          var s = document.createElement('label');
          s.className = 'sb-swatch-name';
          s.setAttribute('for', label.getAttribute('for'));
          s.textContent = name.replace(/\s*\/\s*/g, ' / ');
          li.appendChild(s);
        }
      });
      items.sort(function (x, y) { return x.dataset.sbRank - y.dataset.sbRank; }).forEach(function (li) { ul.appendChild(li); });
      if (actions) actions.remove();
      var anyChecked = items.some(function (li) { var i = li.querySelector('input'); return i && i.checked; });
      if (items.length > SHOW + 2 && !anyChecked) {
        ul.classList.add('sb-collapsed');
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'sb-swatch-toggle';
        btn.textContent = 'Show all ' + items.length + ' colours';
        btn.addEventListener('click', function () {
          var c = ul.classList.toggle('sb-collapsed');
          btn.textContent = c ? 'Show all ' + items.length + ' colours' : 'Show fewer colours';
        });
        ul.insertAdjacentElement('afterend', btn);
      }
    });
  }
  document.addEventListener('DOMContentLoaded', tidy);
  var q = false;
  new MutationObserver(function () {
    if (q) return; q = true;
    requestAnimationFrame(function () { q = false; tidy(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* SABBOT: when 2+ colours are filtered, show a separate card for each matching colour of a hat (e.g. Linda in Navy and Linda in Pink) */
(function () {
  var busy = false;
  function pidOf(c) { var m = (c.id || '').match(/--(\d{6,})--/); return m ? m[1] : null; }
  async function expand() {
    var first = document.querySelector('.product-grid-item');
    if (!first || busy) return;
    var grid = first.parentElement;
    var vals = [].slice.call(document.querySelectorAll('input[name="filter.v.option.color"]:checked')).map(function (i) { return i.value; });
    var key = location.search;
    if (vals.length < 2 || grid.dataset.sbExpanded === key) return;
    grid.dataset.sbExpanded = key;
    busy = true;
    try {
      var sec = document.querySelector('[id^="shopify-section-"][id$="__main"]');
      var sectionId = sec ? sec.id.replace('shopify-section-', '') : null;
      var maps = await Promise.all(vals.map(function (v) {
        var p = new URLSearchParams(location.search);
        p.delete('filter.v.option.color'); p.delete('page');
        p.append('filter.v.option.color', v);
        if (sectionId) p.set('section_id', sectionId);
        return fetch(location.pathname + '?' + p.toString()).then(function (r) { return r.text(); }).then(function (h) {
          var d = new DOMParser().parseFromString(h, 'text/html'), m = {};
          d.querySelectorAll('.product-grid-item').forEach(function (c) { var id = pidOf(c); if (id && !m[id]) m[id] = c; });
          return m;
        });
      }));
      if (!grid.isConnected) return;
      [].slice.call(grid.querySelectorAll(':scope > .product-grid-item')).forEach(function (card) {
        var pid = pidOf(card); if (!pid) return;
        var seen = {}, clones = [];
        maps.forEach(function (m, i) {
          var c = m[pid]; if (!c) return;
          var a = c.querySelector('a[href*="variant="]');
          var href = a ? a.getAttribute('href') : 'x' + i;
          if (seen[href]) return; seen[href] = 1;
          var n = document.importNode(c, true);
          n.id = n.id + '-sb' + i;
          n.classList.add('aos-animate');
          n.querySelectorAll('[data-aos]').forEach(function (e) { e.classList.add('aos-animate'); });
          clones.push(n);
        });
        if (clones.length > 1) {
          clones.forEach(function (n) { grid.insertBefore(n, card); });
          card.remove();
        }
      });
    } catch (e) { /* leave the normal grid in place */ }
    finally { busy = false; }
  }
  document.addEventListener('DOMContentLoaded', expand);
  var q = false;
  new MutationObserver(function () {
    if (q) return; q = true;
    setTimeout(function () { q = false; expand(); }, 150);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();